import React, {Component} from 'react';
import {Card, List} from "antd";
import {Controls} from "./Controls";

export default class UpcomingBidDetailsView extends Component {
  componentDidMount = () => this.props.onMount && this.props.onMount();

  render() {
    const { report: { resource: data } = {}, name, pdfGenerator } = this.props;
    if (!data) return null;

    return (
      <Card
        title={<h1>{name}</h1>}
        extra={[<Controls pdfGenerator={() => pdfGenerator(name)} tooltip={'Emails you a Word document of the upcoming bids report that you can download'}/>]}
      >
        <List id='listElement' dataSource={data} renderItem={(bid) => (
          <div className="upcoming-bid-details">
            <h4>Bid Due</h4>
            <p className="color-primary-0">{bid.bidduedatetime}</p>
            <h4>Title</h4>
            <p><h1 className="color-primary-0">{bid.name}</h1></p>
            <h4>Location</h4>
            <p>{bid.address} {bid.address2}</p>
            <p>{bid.city} {bid.state} {bid.zip}</p>
            <p>{bid.country}</p>
            <h4 className="color-primary-0">Addenda Count</h4>
            <p><h2 className="color-primary-0">{bid.addendums.length}</h2></p>
            <h4>Pre Bid Due</h4>
            <p className={bid.prebidmeetingrequired ? "color-secondary-1-3" : "color-secondary-2-3"}>{bid.prebidmeetingrequired && 'Mandatory '}{bid.prebidmeetingdatetime}</p>
            <h4>Pre Bid Location</h4>
            <p>{bid.prebidmeetinglocation}</p>
            <h4>Estimated Cost</h4>
            <p>{bid.contractsize}</p>
            <h4>Site Owner</h4>
            <p>{bid.siteownername}</p>
            <h4>Architect</h4>
            <p>{bid.architectname}</p>
            <h4>Engineer</h4>
            <p>{bid.engineername}</p>
            <h4>Overview</h4>
            <p className='formatted-text'>{bid.description}</p>
            <hr/>
          </div>
        )}/>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reports/UpcomingBidDetailsView.js